<template>
    <div class="flex flex-col w-full">
        <label v-if="label" :for="inputId" class="font-bold mb-1">{{ label }}</label>

        <vSelect
            v-model="inputValue"
            :get-option-label="
                opt => {
                    return labelBy ? `${labelBy}`.split('.').reduce((o, i) => o[i], opt) : '';
                }
            "
            :class="{
                'border border-red-500 rounded': error
            }"
            :placeholder="placeholder"
            :options="options"
            multiple
            :selectable="() => value.length < selectionLimit"
            :reduce="reduce"
            @input="onChange"
        >
            <template slot="no-options">
                <slot name="placeholder"></slot>
            </template>
            <template slot="option" slot-scope="option">
                <slot v-bind="option" name="option"></slot>
            </template>
            <template slot="selected-option" slot-scope="option">
                <slot v-bind="option" name="selected-option"></slot>
            </template>
        </vSelect>

        <span v-if="error" class="mt-1 text-xs text-italic mt-1 text-red-500">
            {{ error }}
        </span>
    </div>
</template>
<script>
import FormInputMixin from './form_inputs_mixin';

export default {
    components: {
        vSelect: () => import(/* webpackChunkName: "lazy-loaded/vue-select" */ 'vue-select')
    },

    mixins: [FormInputMixin],

    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        labelBy: {
            type: String,
            default: null
        },
        selectionLimit: {
            type: Number,
            default: Number.POSITIVE_INFINITY
        },
        reduce: {
            type: Function,
            default: option => option
        }
    },

    data() {
        return {
            inputValue: this.value
        };
    },

    watch: {
        value: function() {
            this.inputValue = this.value;
        }
    },

    methods: {
        onChange(value) {
            this.$emit('input', value);
        }
    }
};
</script>

<style src="vue-select/dist/vue-select.css"></style>

<style>
.vs__dropdown-toggle {
    @apply py-3 px-3 border border-gray-200 text-gray-700 bg-gray-200;
}

.vs--open .vs__dropdown-toggle {
    @apply outline-none bg-white border border-gray-500;
}

.vs__search {
    @apply text-gray-500;
}

.vs__selected {
    @apply bg-gray-600 text-gray-200 mt-1;
}

.vs__search,
.vs__search:focus {
    @apply mt-0;
}
</style>
